import React from 'react'
import { Link as GatsbyLink, GatsbyLinkProps } from 'gatsby'
import smoothScroller from '@/lib/smoothScroller'
import { Location } from '@reach/router'

// issue: type bug fix from https://github.com/gatsbyjs/gatsby/issues/16682
type Omit<T, K> = Pick<T, Exclude<keyof T, K>>
const Link: React.FC<Omit<GatsbyLinkProps<{} & React.HTMLAttributes<HTMLButtonElement>>, 'ref'>> = ({ children,  to, ...other }) => (
  <Location>
    {({ location }): JSX.Element => {
      // 外部リンクの場合はadd noopener noreferrer
      if (other?.target === '_blank') other.target = '_blank noopener noreferrer'

      // そもそもhttpで始まっていないか
      if (/^(?!http).*/.test(to)) {
        // to とlocationを比較して 遷移 ページ内アニメ を分ける
        const path = new URL(to, location.href || 'https://test.com/')

        const HandleClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void = e => {
          e.preventDefault()
          if (window && document) {
            history.replaceState(null, '', to)
            path.hash && smoothScroller({ to: path.hash })
          }
        }

        // pathnameが同じ場合は、ページ内部リンクと見做す
        if (path.pathname === location.pathname) {
          return (
            <a onClick={HandleClick} {...other}>
              {children}
            </a>
          )
        }

        // 内部リンクであるかを正規表現で判定する
        const isInternal = /^\/(?!\/)/.test(to)
        if (isInternal)
          return (
            <GatsbyLink to={to} {...other}>
              {children}
            </GatsbyLink>
          )
      }
      return (
        <a href={to} {...other}>
          {children}
        </a>
      )
    }}
  </Location>
)

export default Link
